import { getSystemSetting, upsertSystemSetting } from './systemSettingsApi'
import { pageSettingKey, defaultsForPage, type PageSettingsDef } from '../data/pageSettingsRegistry'

export type PageSettingsValues = Record<string, boolean | number | string>

export async function loadPageSettings(def: PageSettingsDef): Promise<PageSettingsValues> {
  const defaults = defaultsForPage(def)
  const raw = await getSystemSetting(pageSettingKey(def.pageId))
  if (!raw) return { ...defaults }
  try {
    const parsed = JSON.parse(raw) as Record<string, unknown>
    const merged: PageSettingsValues = { ...defaults }
    for (const field of def.fields || []) {
      if (parsed[field.key] === undefined || parsed[field.key] === null) continue
      if (field.type === 'boolean') {
        merged[field.key] = parsed[field.key] === true || parsed[field.key] === 'true' || parsed[field.key] === 1
      } else if (field.type === 'number') {
        const n = Number(parsed[field.key])
        merged[field.key] = Number.isFinite(n) ? n : field.defaultValue
      } else {
        merged[field.key] = String(parsed[field.key])
      }
    }
    return merged
  } catch {
    return { ...defaults }
  }
}

export async function savePageSettings(
  def: PageSettingsDef,
  values: PageSettingsValues
): Promise<void> {
  await upsertSystemSetting({
    settingKey: pageSettingKey(def.pageId),
    settingValue: JSON.stringify(values),
    settingType: 'string',
    description: `إعدادات صفحة ${def.label.ar}`,
    descriptionEn: `Page settings: ${def.label.en}`,
  })
}
